import { render } from "./Loading4Dots.vue?vue&type=template&id=bb496df6&scoped=true"
const script = {}

import "./Loading4Dots.vue?vue&type=style&index=0&id=bb496df6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb496df6"]])

export default __exports__